<template>
  <div id="DepartmentManagement"  class="page-content">
      <el-breadcrumb separator="/" >
        <el-breadcrumb-item>内部用户</el-breadcrumb-item>
        <el-breadcrumb-item>客服账号</el-breadcrumb-item>
      </el-breadcrumb>
      <section class="seaerch-wrapper">
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="姓名" :label-width="formLabelWidth3">
            <el-input onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="realname" placeholder="请输入" clearable size="small"></el-input>
          </el-form-item>
          <el-form-item label="用户名" :label-width="formLabelWidth2">
            <el-input onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="username" placeholder="请输入" clearable size="small"></el-input>
          </el-form-item>
          <el-form-item label="状态" :label-width="formLabelWidth2">
            <el-select v-model="status" placeholder="请选择" size="small" clearable>
              <!-- <el-option label="全部" value="" ></el-option> -->
              <el-option :key="1" label="启用" :value="1" ></el-option>
              <el-option :key="2" label="禁用" :value="2" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item></el-form-item>
          <el-form-item></el-form-item>
          <el-form-item>
            <el-button size="small" class="search-btn" @click="theQuery(1)">查询</el-button>
          </el-form-item>
        </el-form>
      </section>
    <div class="page">
      <el-row style="margin-bottom: 8px;">
        <el-col :span="10">
          <el-button type="primary" icon="el-icon-plus" @click="oneStep(1)" style="margin-right: 10px;" size="small">新增</el-button>
          <el-button plain style="margin-right: 10px;" @click="batchEnabled" size="small">批量启用</el-button>
          <el-button plain style="margin-right: 10px;" @click="batchOutage" size="small">批量停用</el-button>
        </el-col>
      </el-row>
      <div class="prompt" style="margin-bottom: 8px;">
        <i class="el-icon-warning" style="margin-left: 20px;margim-right: 10px;color: #108cee;"></i>
        共<span class="promptFont">{{totalNum}}</span>项,已选择<span class="promptFont">{{openNumber}}</span>项
        <span class="promptFont2" @click="toggleSelection([tableData])">勾选全部</span>
        <span class="promptFont">/</span>
        <span class="promptFont2" @click="toggleSelection()">取消勾选</span>
      </div>
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{scope.$index+1}}
          </template>
        </el-table-column>
        <el-table-column prop="realname" label="姓名">
        </el-table-column>
        <el-table-column prop="username" label="用户名" show-overflow-tooltip>
        </el-table-column>
        <el-table-column label="绑定手机">
          <template slot-scope="scope">
            {{ scope.row.mobile }}
            <span v-show="scope.row.mobile == ''">--</span>
            <el-button type="text" v-show="scope.row.mobile != ''" icon="el-icon-connection" @click="unbundlingAccounts(scope.row.mobile)">解绑手机</el-button>
          </template>
        </el-table-column>
        <el-table-column label="所属部门" prop="depart_name">
        </el-table-column>
        <el-table-column label="角色" prop="rolename">
        </el-table-column>
        <el-table-column label="备注说明" prop="memo">
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.status == 1" @change="stateSwitch(scope.row.status,scope.row.id)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit-outline" @click="oneStep(2,scope.row.realname,scope.row.username,scope.row.id,scope.row.roleid,scope.row.departmentid)">编辑</el-button>
            <span class="positionIcon">|</span>
            <el-button type="text" icon="el-icon-user" @click="customers(scope.row.rootdepartname,scope.row.id)">分配客户</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-show="tableData">
        <pagination
          :currentPage="currentPage" :pageSizes="[10, 20, 50, 100]"
          :total="totalNum" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
        </pagination>
      </div>
    </div>
    <!-- 编辑 -->
    <div id="dialog">
      <el-dialog title="编辑" :visible.sync="theEditorShow" :close-on-click-modal='false' width="640px">
        <el-form :model="form" :rules="rules" ref="ruleForm" style="margin-top: 10px;">
          <el-form-item label="姓名" :label-width="formLabelWidth"  prop="realname">
            <el-input onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="form.realname" autocomplete="off" style="width: 420px;" placeholder="请输入姓名" size="small"></el-input>
          </el-form-item>
          <el-form-item label="用户名" :label-width="formLabelWidth"  prop="username">
            <!-- <el-input onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="form.username" autocomplete="off" style="width: 420px;" placeholder="请输入用户名" :disabled="this.useDisble" size="small"></el-input> -->
            <el-input onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="form.username" autocomplete="off" style="width: 420px;" placeholder="请输入用户名" size="small"></el-input>
          </el-form-item>
          <el-form-item label="密码" :label-width="formLabelWidth"  prop="password">
            <el-input onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="form.password" autocomplete="off" style="width: 420px;" placeholder="6 - 16个字符，区分大小写" show-password size="small"></el-input>
          </el-form-item>
          <el-form-item label="服务部门" :label-width="formLabelWidth" prop="departmentId">
            <el-cascader
              :options="this.linkTagData"
              :props="{ children:'subSysDepartmentIn',value: 'id',label: 'departName',checkStrictly: true}"
              v-model="form.departmentId"
              @change="serviceSector(1)"
               size="small"
               style="width: 420px;">
            </el-cascader>
          </el-form-item>
          <el-form-item label="角色菜单" :label-width="formLabelWidth" prop="roleIds">
            <el-select v-model="form.roleIds" placeholder="请选择" size="small" style="width: 420px;">
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.role_name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注说明" :label-width="formLabelWidth">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="form.memo" style="width: 420px;" size="small">
            </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('ruleForm')" size="small">确 定</el-button>
          <el-button @click="theEditorShow = false" size="small" style="margin-left: 10px;" type="TheCustom">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 编辑 -->
      <!-- 新增 -->
      <el-dialog title="新增" :visible.sync="theEditorShow2" :close-on-click-modal='false' width="640px" id="dialog">
        <el-form :model="form2" :rules="rules2" ref="ruleForm2" style="margin-top: 10px;">
          <el-form-item label="姓名" :label-width="formLabelWidth"  prop="realname">
            <el-input onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="form2.realname" autocomplete="off" placeholder="请输入姓名" size="small" style="width: 420px;"></el-input>
          </el-form-item>
          <el-form-item label="用户名" :label-width="formLabelWidth"  prop="username">
            <el-input onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="form2.username" autocomplete="off" placeholder="以字母开头6 - 16个字符包含数字、字母、下划线" size="small" style="width: 420px;float: left;"></el-input>
            <!-- <el-popover placement="top" width="200" trigger="hover" content="用户名不支持修改，请仔细考虑">
              <el-button slot="reference" icon="el-icon-warning-outline" type="text" style="font-size: 20px;float: left;margin-left: 5px;"></el-button>
            </el-popover> -->
          </el-form-item>
          <el-form-item label="密码" :label-width="formLabelWidth"  prop="password">
            <el-input onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="form2.password" autocomplete="off" placeholder="6 - 16个字符，区分大小写" show-password size="small" style="width: 420px;"></el-input>
          </el-form-item>
          <el-form-item label="服务部门" :label-width="formLabelWidth" prop="departmentId">
            <el-cascader
              :options="this.linkTagData"
              :props="{ children:'subSysDepartmentIn',value: 'id',label: 'departName',checkStrictly: true}"
              v-model="form2.departmentId"
              @change="serviceSector(2)"
               size="small"
               style="width: 420px;">
            </el-cascader>
          </el-form-item>
          <el-form-item label="角色菜单" :label-width="formLabelWidth" prop="roleIds">
            <el-select v-model="form2.roleIds" placeholder="请选择" size="small" style="width: 420px;">
              <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.role_name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注说明" :label-width="formLabelWidth">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="form.memo" style="width: 420px;" size="small">
            </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm2('ruleForm2')" size="small">确 定</el-button>
          <el-button @click="theEditorShow2 = false" size="small" style="margin-left: 10px;" type="TheCustom">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 新增 -->
    </div>
    <!-- 停用 -->
    <el-dialog title="提示" :visible.sync="stopPhoneShow" width="20%" style="margin-top: 10%;" id="dialog">
        <div style="display: flex;width: 100%;justify-content:center;">
            <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
           <div>
               <div style="font-size: 16px;">你确认要停用该用户账号吗？</div>
               <div style="font-size: 14px;">停用后
               <span style="color: #e90e24;font-size: 14px;">账号将无法使用</span>
            </div>
           </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="stopPhone()" size="small">确 定</el-button>
          <el-button @click="stopPhoneShow = false" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
        </span>
    </el-dialog>
    <!-- 停用 -->
    <!-- 批量停用 -->
    <el-dialog title="提示" :visible.sync="stopPhoneShow2" width="20%" style="margin-top: 10%;" id="dialog">
        <div style="display: flex;width: 100%;justify-content:center;">
            <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
           <div>
               <div style="font-size: 16px;">你确认要停用勾选的{{openNumber}}项用户账号吗？</div>
               <div style="font-size: 14px;">停用后
               <span style="color: #e90e24;font-size: 14px;">账号将无法使用</span>
            </div>
           </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="openPhone(2)" size="small">确 定</el-button>
          <el-button @click="stopPhoneShow2 = false" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
        </span>
    </el-dialog>
    <!-- 批量停用 -->
    <!-- 启用 -->
    <el-dialog title="提示" :visible.sync="openPhoneShow" width="20%" style="margin-top: 10%;" id="dialog">
        <div style="display: flex;width: 100%;justify-content:center;">
            <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
           <div>
               <div style="font-size: 16px;">你确认要启用该用户账号吗？</div>
               <div style="font-size: 14px;">启用后
               <span style="color: #e90e24;font-size: 14px;">账号将恢复正常使用</span>
            </div>
           </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="stopPhone()" size="small">确 定</el-button>
          <el-button @click="openPhoneShow = false" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
        </span>
    </el-dialog>
    <!-- 启用 -->
    <!-- 批量启用 -->
    <el-dialog title="提示" :visible.sync="openPhoneShow2" width="20%" style="margin-top: 10%;" id="dialog">
        <div style="display: flex;width: 100%;justify-content:center;">
            <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
           <div>
               <div style="font-size: 16px;">你确认要启用勾选的{{openNumber}}项用户账号吗？</div>
               <div style="font-size: 14px;">启用后
               <span style="color: #e90e24;font-size: 14px;">账号将恢复正常使用</span>
            </div>
           </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="openPhone(1)" size="small">确 定</el-button>
          <el-button @click="openPhoneShow2 = false" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
        </span>
    </el-dialog>
    <!-- 批量启用 -->
    <!-- 解绑 -->
    <el-dialog title="提示" :visible.sync="unbundlingPhoneShow" width="20%" style="margin-top: 10%;" id="dialog">
        <div style="display: flex;width: 100%;justify-content:center;">
            <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
           <div>
               <div class="font-size: 16px;">你确认要解绑该用户绑定手机吗？</div>
               <div class="font-size: 14px;">解绑后
               <span style="color: #e90e24;font-size: 14px;">账号将取消当前绑定手机</span>
            </div>
           </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="unbundlingPhone()" size="small">确 定</el-button>
          <el-button @click="unbundlingPhoneShow = false" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
        </span>
    </el-dialog>
    <!-- 解绑 -->
    <!-- 分配客户 -->
    <el-dialog title="分配客户" :visible.sync="customersShow" :close-on-click-modal='false' width="640px" id="dialog2">
      <div class="bigDiv">
        <div class="dispensabilityDiv">
          <!-- 可分配客户 -->
          <div class="dispensabilityHeader">
            <span style="margin-left: 20px;color: #666;">可分配客户</span>
          </div>
          <div style="margin: 10px 20px 20px 20px;">
            <el-input onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="name" placeholder="请输入用户名查找" size="small" @keyup.enter.native="usernameLookup"></el-input>
            <i class="el-icon-search" style="position: absolute;top: 136px;left: 297px;cursor: pointer;" @click="usernameLookup"></i>
            <div class="searchDiv" style="height: 154px;overflow-y: auto;">
              <div class="dispensabilityFont" v-for="item in dispensabilityData">
                <div style="float: left;">
                  <span style="margin-left: 10px;width: 195px;" class="beyondHidden" v-if="item.companyMemoname">{{item.companyMemoname}}</span>
                  <span style="margin-left: 10px;width: 195px;" class="beyondHidden" v-else>{{item.companyname}}</span>
                </div>
                <div style="float: right;">
                  <span style="color: #409eff;margin-right: 10px;cursor: pointer;" v-if="item.WhetherAdd === false" @click="addAssigned(item.companyMemoname,item.companyname,item.bmcid)">添加</span>
                  <span style="color: #999;margin-right: 10px;cursor: not-allowed" v-else>已添加</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 快捷复用客户 -->
          <div class="dispensabilityHeader2">
            <span style="margin-left: 20px;color: #666;">快捷复用客户</span>
          </div>
          <div style="margin: 10px 20px 20px 20px;">
            <el-input onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="dispensabilityName" placeholder="请输入客服名查询" size="small" @keyup.enter.native="serviceNameSearch"></el-input>
            <i class="el-icon-search" style="position: absolute;top: 397px;left: 297px;cursor: pointer;" @click="serviceNameSearch"></i>
            <div class="searchDiv" style="height: 92px;overflow-y: auto;">
              <div class="dispensabilityFont" v-for="item in quickData">
                <div style="float: left;">
                  <span style="margin-left: 10px;width: 195px;" class="beyondHidden">{{item.realname}}</span>
                </div>
                <div style="float: right;">
                  <span style="color: #409eff;margin-right: 10px;cursor: pointer;" @click="reuseCustomer(item.bmcList)" v-if="item.bmcList && item.bmcList.length > 0">复用客户</span>
                  <span style="color: #606266;margin-right: 10px;cursor: not-allowed;" v-else>复用客户</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 已分配客户 -->
        <div class="allocated">
          <div class="allocatedHeader">
            <span style="margin-left: 20px;color: #666;">已分配客户</span>
          </div>
          <div style="margin: 10px 20px 0px 20px;">
            <el-input onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" v-model="search" placeholder="请输入用户名查找" size="small" @keyup.enter.native="searchbtn"></el-input>
            <i class="el-icon-search" style="position: absolute;top: 136px;left: 517px;cursor: pointer;" @click="searchbtn"></i>
          </div>
          <div style="height: 360px;line-height: 360px;text-align: center;" v-if="AssignedCustomerData.length < 1 && !AssDataShow">
            <span style="color: #999;">暂无分配客户</span>
          </div>
          <div style="height: 360px;line-height: 360px;text-align: center;" v-if="AssDataDelete.length < 1 && AssDataShow == true">
            <span style="color: #999;">暂无分配客户</span>
          </div>
          <div style="height: 360px;overflow-y: auto;width: 244px;">
            <div class="allocatedDiv" v-for="item in AssignedCustomerData" v-if="!AssDataShow">
              <div class="beyondHidden" style="width: 150px;" v-if="item.company_memoname">
                {{item.company_memoname}}
              </div>
              <div class="beyondHidden" style="width: 150px;" v-else>
                {{item.companyname}}
              </div>
              <div style="float: right;">
                <i class="el-icon-close" style="cursor: pointer;" @click="AssignedCustomerDelet(item.bmcid)"></i>
              </div>
            </div>
            <div class="allocatedDiv" v-for="item in AssDataDelete" v-if="AssDataShow == true">
              <div class="beyondHidden" style="width: 150px;" v-if="item.company_memoname">
                {{item.company_memoname}}
              </div>
              <div class="beyondHidden" style="width: 150px;" v-else>
                {{item.companyname}}
              </div>
              <div style="float: right;">
                <i class="el-icon-close" style="cursor: pointer;" @click="AssignedCustomerDelet(item.bmcid)"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveBmcByKefu()" size="small">确 定</el-button>
        <el-button @click="customersShow = false" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import aes from "../../libs/aes";
  import pagination from "../../components/dataTable/pagination";
  export default {
    data() {
      return {
        AssDataShow: false,
        searchData: '',
        search: '',
        kefuid: '',
        name: '',
        customersType: '',
        dispensabilityName: '',
        dispensabilityData: [],
        AssignedCustomerData: [],
        AssDataDelete: [],
        tableData: [],
        multipleSelection: [],
        linkTagData: [],
        quickData: [],
        // subSysDepartmentIn: {
        //   value: 'id',
        //   label: 'departName',
        //   // children: 'subSysDepartmentIn',
        // },
        options: [],
        dataId: '',
        formDepartmentId: '',
        formDepartmentId2: '',
       value: '',
       value1: [],
       realname: '',
       username: '',
       status: '',
       batchUserIds: '',
       iprTheEditordata: [],
       useDisble: false,
       theEditorShow: false,
       theEditorShow2: false,
       stopPhoneShow: false,
       stopPhoneShow2: false,
       openPhoneShow: false,
       openPhoneShow2: false,
       unbundlingPhoneShow: false,
       customersShow: false,
       openNumber: 0,
       totalNum: 100,
       pageNo: 1,
       pageSize: 10,
       currentPage: 1,
       checkAll: 0,
       userIds: '',
       openStatus: '',
       mobiles: '',
       rules: {
         realname: [
           { required: true, message: '请输入姓名', trigger: 'blur' },
         ],
         username: [
           { required: true, message: '请输入用户名', trigger: 'blur' },
         ],
         password: [
           { required: true, message: '请输入密码', trigger: 'blur' },
         ],
         departmentId: [
           { required: true, message: '请选择部门', trigger: 'blur' },
         ],
         roleIds: [
           { required: true, message: '请选择角色菜单', trigger: 'blur' },
         ],
       },
       rules2: {
         realname: [
           { required: true, message: '请输入姓名', trigger: 'blur' },
         ],
         username: [
           { required: true, message: '请输入用户名', trigger: 'blur' },
         ],
         password: [
           { required: true, message: '请输入密码', trigger: 'blur' },
         ],
         departmentId: [
           { required: true, message: '请选择部门', trigger: 'blur' },
         ],
         roleIds: [
           { required: true, message: '请选择角色菜单', trigger: 'blur' },
         ],
       },
       formLabelWidth: '120px',
       formLabelWidth2: '100px',
       formLabelWidth3: '70px',
       form: {
         realname: '',
         username: '',
         password: '******',
         roleIds: '',
         memo: '',
         departmentId: [],
       },
       form2: {
         realname: '',
         username: '',
         password: '',
         departmentId: [],
         memo: '',
         roleIds: '',
       },
      }
    },
    mounted() {
      this.theQuery();
    },
    methods: {
      searchbtn() {
        let arr
        if (this.search != '') {
          arr = this.AssignedCustomerData.filter( item =>
            item.company_memoname.indexOf(this.search) > -1
            || item.companyname.indexOf(this.search) > -1
          );
          this.AssDataDelete = arr
          this.AssDataShow = true
        } else {
          this.AssDataShow = false
        }
      },
      // 分配客户保存
      saveBmcByKefu() {
        let arr = []
        for (var i = 0; i < this.AssignedCustomerData.length; i++) {
          arr.push(this.AssignedCustomerData[i].bmcid)
        }
        let params={
          bmcids: arr.join(","),
          type: this.customersType,
          kefuid: this.kefuid
        }
        fetch({
          url: "hcm/userin/saveBmcByKefu",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.customersShow = false
            this.$message({
              message: '保存成功',
              type: 'success'
            });
          } else {
            this.$message.error(res.message)
          }
        })
      },
      // 已分配客户删除
      AssignedCustomerDelet(bmcid) {
        for (var i = 0; i < this.AssignedCustomerData.length; i++) {
          if (this.AssignedCustomerData[i].bmcid == bmcid) {
            this.AssignedCustomerData.splice(i,1);
          }
        }
        for (var i = 0; i < this.AssDataDelete.length; i++) {
          if (this.AssDataDelete[i].bmcid == bmcid) {
            this.AssDataDelete.splice(i,1);
          }
        }
        for (var i = 0; i < this.dispensabilityData.length; i++) {
          if (this.dispensabilityData[i].bmcid === bmcid) {
            this.dispensabilityData[i].WhetherAdd = false
          }
        }
      },
      // 复用客户
      reuseCustomer(bmcList) {
        for (var z = 0; z < bmcList.length; z++) {
          this.AssignedCustomerData.push({
            company_memoname:bmcList[z].company_memoname,
            companyname:bmcList[z].companyname,
            bmcid:bmcList[z].bmcid,
          })
          for (var i = 0; i < this.dispensabilityData.length; i++) {
            if (this.dispensabilityData[i].bmcid === bmcList[z].bmcid) {
              this.dispensabilityData[i].WhetherAdd = true
            }
          }
        }
        for (var i = 0; i < this.AssignedCustomerData.length; i++) {
          for (var j = i+1; j < this.AssignedCustomerData.length; j++) {
            if (this.AssignedCustomerData[i].bmcid == this.AssignedCustomerData[j].bmcid) {
              this.AssignedCustomerData.splice(j,1);
              j--;
            }
          }
        }
        this.$message({
          message: '复用成功',
          type: 'success'
        });
      },
      // 添加
      addAssigned(companyMemoname,companyname,bmcid) {
        for (var i = 0; i < this.AssignedCustomerData.length; i++) {
          if (this.AssignedCustomerData[i].bmcid == bmcid) {
            this.AssignedCustomerData.splice(i,1);
          }
        }
        // push到已分配客户
        this.AssignedCustomerData.push({
          company_memoname: companyMemoname,
          companyname: companyname,
          bmcid: bmcid
        })
        // 改变可分配客户状态
        for (var i = 0; i < this.dispensabilityData.length; i++) {
          if (this.dispensabilityData[i].bmcid === bmcid) {
            this.dispensabilityData[i].WhetherAdd = true
          }
        }
        this.$message({
          message: '添加成功',
          type: 'success'
        });
      },
      // 名称获取品牌方
      usernameLookup() {
        this.dispensabilityData = []
        if (this.name == '') {
          this.$message({
            message: '请输入用户名',
            type: 'warning'
          });
          return
        }
        let params={
          name: this.name,
          type: this.customersType
        }
        fetch({
          url: "/hcm/cus/getBmcByName",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.dispensabilityData = []
            if (res.data.length > 0) {
              for (var i = 0; i < res.data.length; i++) {
                this.dispensabilityData.push({
                  companyMemoname:res.data[i].companyMemoname,
                  companyname:res.data[i].companyname,
                  bmcid:res.data[i].bmcid,
                  WhetherAdd:false,
                })
              }
              for (var a = 0; a < this.AssignedCustomerData.length; a++) {
                for (var z = 0; z < this.dispensabilityData.length; z++) {
                  if (this.AssignedCustomerData[a].bmcid == this.dispensabilityData[z].bmcid ) {
                    this.dispensabilityData[z].WhetherAdd = true
                  }
                }
              }
            } else {
              this.$message({
                message: '暂无当前用户',
                type: 'warning'
              });
            }
          } else {
            this.$message.error(res.message)
          }
        })
      },
      // 姓名查询客服
       serviceNameSearch() {
         this.quickData = []
         if(this.dispensabilityName == '') {
           this.$message({
             message: '请输入客服名',
             type: 'warning'
           });
           return
         }
        let params={
          realname: this.dispensabilityName,
          // type: this.customersType
        }
        fetch({
          url: "/hcm/userin/getListByRealname",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.quickData = res.data
            if (this.quickData.length == 0) {
              this.$message({
                message: '暂无当前客服',
                type: 'warning'
              });
            }
          } else {
            this.$message.error(res.message)
          }
        })
      },
      // 触发分配客户
      customers(type,id) {
        this.search = ''
        this.AssDataDelete = []
        this.kefuid = id
        this.name = ''
        this.dispensabilityName = ''
        this.quickData = []
        this.dispensabilityData = []
        this.AssignedCustomerData = []
        this.customersShow = true
        this.customersType = 'brm'
        // if (type.substring(0,3) === 'BRM') {
        //   this.customersType = 'brm'
        // } else {
        //   this.customersType = 'ipr'
        // }
        let params={
          kefuid: id,
        }
        fetch({
          url: "/hcm/userin/getBmcListByKefuid",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.AssignedCustomerData = res.data
          } else {
            this.$message.error(res.message)
          }
        })
      },
      theQuery(e) {
        if (e == 1) {
          this.pageNo = 1
          this.currentPage = 0
        }
        let params={
          pageNo: this.pageNo,
          pageSize: this.pageSize
        }
        if (this.realname) {
          params.realname = this.realname;
        }
        if (this.username) {
          params.username = this.username;
        }
        if (this.status) {
          params.status = this.status;
        }
        fetch({
          url: "hcm/userin/getlist",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.currentPage = 1
            this.tableData = data.userin_list;
            this.totalNum = data.page_info.totalNum;
          } else {
            this.$message.error(res.message)
          }
        })
      },
      serviceSector(e) {
        if (e == 1) {
          var hh = this.form.departmentId.length
          var bb = hh - 1
          this.formDepartmentId = this.form.departmentId[bb]
        } else {
          var hh = this.form2.departmentId.length
          var bb = hh - 1
          this.formDepartmentId2 = this.form2.departmentId[bb]
        }
      },
      oneStep(e,f,h,k,l,q) {
        this.form2.realname = '';
        this.form2.username = '';
        this.form2.password = '';
        this.form2.roleIds = '';
        this.form2.memo = '';
        this.form2.departmentId = '';
        this.form.memo = '';
        this.dataId = k;
        if (l) {
          this.form.roleIds = parseInt(l);
        } else {
          this.form.roleIds = '';
        }
        if (q) {
          this.form.departmentId = parseInt(q);
          this.formDepartmentId = parseInt(q);
        } else {
          this.form.departmentId = '';
        }
        let params={
          id:0
        }
        fetch({
          url: "hcm/departmentin/fuByIds",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            if (e == 1) {
              this.theEditorShow2 = true;
            } else {
              this.theEditorShow = true;
              this.form.realname = f;
              this.form.username = h;
              this.useDisble = true;
            }
            this.linkTagData = data;
            this.menu();
          }
        })
      },
      menu() {
        let params={
          pageNo: 1,
          pageSize: 999
        }
        fetch({
          url: "hcm/role/getRolePage",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.options = data.content;
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {

        })
      },
      disableAccounts() {
        this.stopPhoneShow = true
      },
      openAccounts() {
        this.openPhoneShow = true
      },
      unbundlingAccounts(e) {
        this.mobiles = e;
        this.unbundlingPhoneShow = true;
      },
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleAllSelection(row);
            this.openNumber = this.totalNum
            this.checkAll = 2
          });
        } else {
          this.$refs.multipleTable.clearSelection();
          this.checkAll = 1
          this.openNumber = 0
        }
      },
      handleSizeChange(val) {
        this.pageSize = `${val}`
        this.theQuery();
      },
      handleCurrentChange(val) {
        this.pageNo = `${val}`
        this.theQuery();
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      stateSwitch(e,f) {
        this.userIds = f;
        this.openStatus = e;
        if (e == 1) {
          this.disableAccounts();
        } else {
          this.openAccounts();
        }
      },
      batchEnabled() {
        if (this.multipleSelection.length != 0) {
          this.openPhoneShow2 = true;
          if (this.checkAll == 2) {
            this.openNumber = this.totalNum;
          } else {
            this.openNumber = this.multipleSelection.length;
          }
        } else {
          this.$message({
            message: '请选择要启用的用户',
            type: 'warning'
          });
        }
      },
      batchOutage() {
        if (this.multipleSelection.length != 0) {
          this.stopPhoneShow2 = true;
          if (this.checkAll == 2) {
            this.openNumber = this.totalNum;
          } else {
            this.openNumber = this.multipleSelection.length;
          }
        } else {
          this.$message({
            message: '请选择要停用的用户',
            type: 'warning'
          });
        }
      },
      stopPhone() {
        let params={
          userIds: this.userIds,
          usertype: 'u'
        }
        if (this.openStatus == 1) {
          params.status = 2
        } else {
          params.status = 1
        }
        fetch({
          url: "hcm/user/StartOrStop",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.theQuery();
            this.stopPhoneShow = false;
            this.openPhoneShow = false;
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {

        })
      },
      openPhone(e) {
        var arr = [];
        this.multipleSelection.forEach((val,index,val_arr)=>{
          arr.push(val.id)
        });
        let params={
          usertype: 'u'
        }
        if (this.checkAll == 2) {
          params.userIds = 'checkAllKefu'
        } else {
          this.batchUserIds = arr.join();
          params.userIds = this.batchUserIds
        }
        if (e == 1) {
          params.status = 1
        } else {
          params.status = 2
        }
        fetch({
          url: "hcm/user/StartOrStop",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.theQuery();
            this.openPhoneShow2 = false;
            this.stopPhoneShow2 = false;
            this.checkAll = 1
            this.openNumber = 0
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {

        })

      },
      unbundlingPhone() {
        let params={
          mobiles: this.mobiles,
          usertype: 'u'
        }
        fetch({
          url: "hcm/user/UnbindPhone",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.theQuery();
            this.unbundlingPhoneShow = false;
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(err => {

        })

      },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params={
              realname: this.form.realname,
              username: this.form.username,
              password: aes.encrypt(this.form.password,'hcmabcdefghijklm'),
              roleIds: this.form.roleIds,
              memo: this.form.memo,
              departmentId: this.formDepartmentId,
              id: this.dataId,
            }
            fetch({
              url: "hcm/userin/update",
              method: "post",
              params: params,
              noFormat: true,
              responseType: "text"
            }).then(result => {
              let res = JSON.parse(result);
              let {data}=res
              if(res.status == '10000'){
                this.theEditorShow = false
                this.theQuery();
              } else if (res.status == '10001') {
                this.$message.error('用户名称重复');
                this.theEditorShow = false
              } else if (res.status == '10011') {
                this.$message.error('用户创建失败');
                this.theEditorShow = false
              }
            })
            .catch(err => {

            })
          } else {
            return false;
          }
        });
      },
      submitForm2(formName2) {
        this.$refs[formName2].validate((valid) => {
          if (valid) {
            let params={
              realname: this.form2.realname,
              username: this.form2.username,
              password: aes.encrypt(this.form2.password,'hcmabcdefghijklm'),
              roleIds: this.form2.roleIds,
              memo: this.form2.memo,
              departmentId: this.formDepartmentId2,
            }
            fetch({
              url: "hcm/userin/create",
              method: "post",
              params: params,
              noFormat: true,
              responseType: "text"
            }).then(result => {
              let res = JSON.parse(result);
              let {data}=res
              if(res.status == '10000'){
                this.theEditorShow2 = false
                this.theQuery();
              } else if (res.status == '10001') {
                this.$message.error('用户名称重复');
                this.theEditorShow2 = false
              } else if (res.status == '10011') {
                this.$message.error('用户创建失败');
                this.theEditorShow2 = false
              }
            })
            .catch(err => {

            })
          } else {
            return false;
          }
        });
      },
    },
    components: {
        pagination
    }
  }
</script>
<style lang="scss">
#DepartmentManagement {
  .beyondHidden {
    float: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .allocatedDiv {
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    margin-right: 20px;
  }
  .dispensabilityFont {
    height: 20px;
    width: 100%;
    line-height: 20px;
    font-size: 15px;
    margin-bottom: 3px;
  }
  .searchDiv {
    width: 100%;
    margin-top: 5px;
  }
  .dispensabilityHeader {
    width: 319px;
    height: 40px;
    background-color: #f6f7fb;
    font-size: 14px;
    line-height: 40px;
  }
  .dispensabilityHeader2 {
    width: 319px;
    height: 40px;
    font-size: 14px;
    line-height: 40px;
  }
  .dispensabilityDiv {
    width: 348px;
    border-right: 1px solid #d9d9d9;
    height: 100%;
  }
  .allocatedHeader {
    width: 241px;
    height: 40px;
    background-color: #f6f7fb;
    font-size: 14px;
    line-height: 40px;
  }
  .allocated {
    width: 218px;
    height: 100%;
  }
  .bigDiv {
    width: 590px;
    height: 445px;
    border: 1px solid #d9d9d9;
    display: flex;
  }
  .header {
    width: 100%;
    height: 40px;
    background-color: white;
  }
  .page {
    padding: 20px;
    margin-top: 10px;
    background-color: white;
    height: 870px;
  }
  .page2 {
    padding: 20px;
    // margin: 20px;
    background-color: white;
  }
  .headerSize {
    line-height: 28px;
    text-align: right;
  }
  .prompt {
    height: 28px;
    border: 1px solid #108cee;
    background-color: #e6f7ff;
    border-radius: 5px;
    line-height: 28px;
    margin-bottom: 5px;
  }
  .promptFont{
    color: #108cee;
    font-size: 14px;
    margin-left: 3px;
    margin-right: 3px;
  }
  .promptFont2{
    color: #108cee;
    font-size: 14px;
    margin-left: 3px;
    margin-right: 3px;
    cursor: pointer;
  }
  .block {
    text-align: right;
    margin-top: 20px;
  }
  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }
  .el-button--TheCustom:hover  {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }
  .positionIcon {
    color: #d9d9d9;
    padding-left: 7px;
    padding-right: 7px;
    font-weight: 200;
  }
  .el-table__empty-text{
    padding-top: 100px;
    background: url("../../assets/img/other/nodata.svg") no-repeat;
    background-position: center 66px;
  }
  .el-table th {
    background-color: #f3f7ff !important;
  }
  .el-table thead {
    color: #333333;
    font-weight: 500;
  }
  .el-dialog__title {
    font-size: 16px;
  }
  #dialog {
    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #d9d9d9;
    }
    .el-button--primary {
      color: #FFF;
      background-color: #bda571;
      border-color: #bda571;
    }
    .el-button--primary:hover {
      color: #FFF;
      background-color: #c0ae8a;
      border-color: #c0ae8a;
    }
  }
  #dialog2 {
    .el-dialog__footer {
      padding: 0px 20px 20px;
      text-align: right;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }
    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #d9d9d9;
    }
    .el-button--primary {
      color: #FFF;
      background-color: #bda571;
      border-color: #bda571;
    }
    .el-dialog__body {
      padding: 20px 20px;
      color: #606266;
      font-size: 14px;
      word-break: break-all;
    }
    .el-button--primary:hover {
      color: #FFF;
      background-color: #c0ae8a;
      border-color: #c0ae8a;
    }
  }
  .el-button+.el-button {
    margin-left: 1px;
  }
}
</style>
